"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKIconName = void 0;
var GKIconName;
(function (GKIconName) {
    GKIconName["AccountBox"] = "account_box";
    GKIconName["Add"] = "add";
    GKIconName["AddAlert"] = "add_alert";
    GKIconName["AddComment"] = "add_comment";
    GKIconName["AddLocation"] = "add_location";
    GKIconName["AddPhotoAlternate"] = "add_photo_alternate";
    GKIconName["Announcement"] = "announcement";
    GKIconName["ArrowDropDown"] = "arrow_drop_down";
    GKIconName["ArrowDropUp"] = "arrow_drop_up";
    GKIconName["ArrowBack"] = "arrow_back";
    GKIconName["ArrowDownward"] = "arrow_downward";
    GKIconName["ArrowForward"] = "arrow_forward";
    GKIconName["ArrowUpward"] = "arrow_upward";
    GKIconName["AttachFile"] = "attach_file";
    GKIconName["Autorenew"] = "autorenew";
    GKIconName["BarChart"] = "bar_chart";
    GKIconName["Beenhere"] = "beenhere";
    GKIconName["BookmarkBorder"] = "bookmark_border";
    GKIconName["Bookmark"] = "bookmark";
    GKIconName["Bookmarks"] = "bookmarks";
    GKIconName["BoundaryDivide"] = "boundary_divide";
    GKIconName["BoundaryMerge"] = "boundary_merge";
    GKIconName["BrokenImage"] = "broken_image";
    GKIconName["CalendarToday"] = "calendar_today";
    GKIconName["CameraAlt"] = "camera_alt";
    GKIconName["Cancel"] = "cancel";
    GKIconName["Carbon"] = "carbon";
    GKIconName["ChatBubbleOutline"] = "chat_bubble_outline";
    GKIconName["ChatBubble"] = "chat_bubble";
    GKIconName["Chat"] = "chat";
    GKIconName["Check"] = "check";
    GKIconName["CheckCircle"] = "check_circle";
    GKIconName["CheckCircleOutline"] = "check_circle_outline";
    GKIconName["Chemical"] = "chemical";
    GKIconName["ChemicalFull"] = "chemical_full";
    GKIconName["Clear"] = "clear";
    GKIconName["CloseFullscreen"] = "close_fullscreen";
    GKIconName["Cloud"] = "cloud";
    GKIconName["CloudQueue"] = "cloud_queue";
    GKIconName["Code"] = "code";
    GKIconName["Comment"] = "comment";
    GKIconName["Compare"] = "compare";
    GKIconName["CompareArrows"] = "compare_arrows";
    GKIconName["CompareLayers"] = "compare_layers";
    GKIconName["ContentCopy"] = "content_copy";
    GKIconName["ControlCamera"] = "control_camera";
    GKIconName["CornYield"] = "corn_yield";
    GKIconName["CropSelection"] = "crop_selection";
    GKIconName["CropsMultiple"] = "crops_multiple";
    GKIconName["DateRange"] = "date_range";
    GKIconName["Delete"] = "delete";
    GKIconName["DeleteOutline"] = "delete_outline";
    GKIconName["Directions"] = "directions";
    GKIconName["DoneAll"] = "done_all";
    GKIconName["DoneOutline"] = "done_outline";
    GKIconName["Done"] = "done";
    GKIconName["DragIndicator"] = "drag_indicator";
    GKIconName["DrawFreeform"] = "draw_freeform";
    GKIconName["DrawFreeFormAdd"] = "draw_freeform_add";
    GKIconName["DrawFreeFormRemove"] = "draw_freeform_remove";
    GKIconName["DrawPath"] = "draw_path";
    GKIconName["Edit"] = "edit";
    GKIconName["Ellipse"] = "ellipse";
    GKIconName["EllipseAdd"] = "ellipse_add";
    GKIconName["EllipseSubtract"] = "ellipse_subtract";
    GKIconName["Error"] = "error";
    GKIconName["ErrorOutline"] = "error_outline";
    GKIconName["EventAvailable"] = "event_available";
    GKIconName["EventBusy"] = "event_busy";
    GKIconName["EventNote"] = "event_note";
    GKIconName["FavoriteBorder"] = "favorite_border";
    GKIconName["Favorite"] = "favorite";
    GKIconName["FertilizerK"] = "fertilizer_k";
    GKIconName["FertilizerL"] = "fertilizer_l";
    GKIconName["FertilizerN"] = "fertilizer_n";
    GKIconName["FertilizerP"] = "fertilizer_p";
    GKIconName["Fertilizer"] = "fertilizer";
    GKIconName["Field"] = "field";
    GKIconName["Fields"] = "fields";
    GKIconName["FileCopy"] = "file_copy";
    GKIconName["FileCopyOutline"] = "file_copy_outline";
    GKIconName["FileOutline"] = "file_outline";
    GKIconName["File"] = "file";
    GKIconName["FilterCenterFocus"] = "filter_center_focus";
    GKIconName["FlagOutline"] = "flag_outline";
    GKIconName["Flag"] = "flag";
    GKIconName["Forward"] = "forward";
    GKIconName["Grazing"] = "grazing";
    GKIconName["Harvest"] = "harvest";
    GKIconName["Help"] = "help";
    GKIconName["HelpOutline"] = "help_outline";
    GKIconName["History"] = "history";
    GKIconName["Home"] = "home";
    GKIconName["ImportExport"] = "import_export";
    GKIconName["Info"] = "info";
    GKIconName["InfoOutline"] = "info_outline";
    GKIconName["InsertChartOutlined"] = "insert_chart_outlined";
    GKIconName["InsertChart"] = "insert_chart";
    GKIconName["InsertComment"] = "insert_comment";
    GKIconName["IrrigationOutline"] = "irrigation_outline";
    GKIconName["Irrigation"] = "irrigation";
    GKIconName["KeyboardArrowDown"] = "keyboard_arrow_down";
    GKIconName["KeyboardArrowLeft"] = "keyboard_arrow_left";
    GKIconName["KeyboardArrowRight"] = "keyboard_arrow_right";
    GKIconName["KeyboardArrowUp"] = "keyboard_arrow_up";
    GKIconName["Label_Important"] = "label_important";
    GKIconName["Label"] = "label";
    GKIconName["Language"] = "language";
    GKIconName["Launch"] = "launch";
    GKIconName["Layers"] = "layers";
    GKIconName["LayersClear"] = "layers_clear";
    GKIconName["Link"] = "link";
    GKIconName["List"] = "list";
    GKIconName["ListAlt"] = "list_alt";
    GKIconName["LocationOn"] = "location_on";
    GKIconName["LockOpen"] = "lock_open";
    GKIconName["Lock"] = "lock";
    GKIconName["Login"] = "login";
    GKIconName["LogomarkVisor"] = "logomark_visor";
    GKIconName["Logout"] = "logout";
    GKIconName["Mail"] = "mail";
    GKIconName["MailOutline"] = "mail_outline";
    GKIconName["Map"] = "map";
    GKIconName["MapLayer"] = "map_layer";
    GKIconName["MapLayerOff"] = "map_layer_off";
    GKIconName["MarkChatRead"] = "mark_chat_read";
    GKIconName["MarkChatUnread"] = "mark_chat_unread";
    GKIconName["MarkEmailRead"] = "mark_email_read";
    GKIconName["MarkEmailUnread"] = "mark_email_unread";
    GKIconName["Menu"] = "menu";
    GKIconName["MenuOpen"] = "menu_open";
    GKIconName["Message"] = "message";
    GKIconName["MoreHoriz"] = "more_horiz";
    GKIconName["MoreVert"] = "more_vert";
    GKIconName["MyLocation"] = "my_location";
    GKIconName["NearMe"] = "near_me";
    GKIconName["Note"] = "note";
    GKIconName["NoteAdd"] = "note_add";
    GKIconName["NoteEdit"] = "note_edit";
    GKIconName["Notifications"] = "notifications";
    GKIconName["NotificationImportant"] = "notification_important";
    GKIconName["NotificationsActive"] = "notifications_active";
    GKIconName["OpenInFull"] = "open_in_full";
    GKIconName["OpenInNew"] = "open_in_new";
    GKIconName["PartlyCloudy"] = "partly_cloudy";
    GKIconName["PdfReport"] = "pdf_report";
    GKIconName["PendingActions"] = "pending_actions";
    GKIconName["People"] = "people";
    GKIconName["PersonAdd"] = "person_add";
    GKIconName["PersonOutline"] = "person_outline";
    GKIconName["PersonRemove"] = "person_remove";
    GKIconName["Person"] = "person";
    GKIconName["Phone"] = "phone";
    GKIconName["Planting"] = "planting";
    GKIconName["PlayArrow"] = "play_arrow";
    GKIconName["PlayCircleOutline"] = "play_circle_outline";
    GKIconName["Polygon"] = "polygon";
    GKIconName["PolygonAdd"] = "polygon_add";
    GKIconName["PolygonSubtract"] = "polygon_subtract";
    GKIconName["Precipitation"] = "precipitation";
    GKIconName["Preview"] = "preview";
    GKIconName["Print"] = "print";
    GKIconName["Publish"] = "publish";
    GKIconName["PushPin"] = "push_pin";
    GKIconName["Rectangle"] = "rectangle";
    GKIconName["RectangleAdd"] = "rectangle_add";
    GKIconName["RectangleSubtract"] = "rectangle_subtract";
    GKIconName["Receipt"] = "receipt";
    GKIconName["Redo"] = "redo";
    GKIconName["Refresh"] = "refresh";
    GKIconName["Remove"] = "remove";
    GKIconName["ReplyAll"] = "reply_all";
    GKIconName["Reply"] = "reply";
    GKIconName["Restore"] = "restore";
    GKIconName["SaveAlt"] = "save_alt";
    GKIconName["ScanDoc"] = "scan_doc";
    GKIconName["Search"] = "search";
    GKIconName["Security"] = "security";
    GKIconName["Settings"] = "settings";
    GKIconName["Share"] = "share";
    GKIconName["Snowy"] = "snowy";
    GKIconName["StarBorder"] = "star_border";
    GKIconName["Star"] = "star";
    GKIconName["Summary"] = "summary";
    GKIconName["Sunny"] = "sunny";
    GKIconName["SwapHoriz"] = "swap_horiz";
    GKIconName["SwapVert"] = "swap_vert";
    GKIconName["TStorm"] = "t_storm";
    GKIconName["Task"] = "task";
    GKIconName["TaskOutline"] = "task_outline";
    GKIconName["ThreatId"] = "threat_id";
    GKIconName["ThumbDown"] = "thumb_down";
    GKIconName["ThumbDownOffAlt"] = "thumb_down_off_alt";
    GKIconName["ThumbUp"] = "thumb_up";
    GKIconName["ThumbUpOffAlt"] = "thumb_up_off_alt";
    GKIconName["ThumbsUpDown"] = "thumbs_up_down";
    GKIconName["Tillage"] = "tillage";
    GKIconName["Timeline"] = "timeline";
    GKIconName["Today"] = "today";
    GKIconName["TrendDown"] = "trend_down";
    GKIconName["TrendNeutral"] = "trend_neutral";
    GKIconName["TrendUp"] = "trend_up";
    GKIconName["Tune"] = "tune";
    GKIconName["Undo"] = "undo";
    GKIconName["UnfoldLess"] = "unfold_less";
    GKIconName["UnfoldMore"] = "unfold_more";
    GKIconName["Update"] = "update";
    GKIconName["UsbStick"] = "usb_stick";
    GKIconName["Verified"] = "verified";
    GKIconName["ViewList"] = "view_list";
    GKIconName["Visibility"] = "visibility";
    GKIconName["VisibilityOff"] = "visibility_off";
    GKIconName["Warning"] = "warning";
    GKIconName["ZoomIn"] = "zoom_in";
    GKIconName["ZoomOutMap"] = "zoom_out_map";
    GKIconName["ZoomOut"] = "zoom_out";
})(GKIconName = exports.GKIconName || (exports.GKIconName = {}));
exports.default = GKIconName;
